import { Component, EventEmitter, Inject, Output, ViewChild } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { defaultMoreFilters, MoreFilters } from '../more-filters'
import { SearchFiltersExtendedComponent } from '../search-filters-extended/search-filters-extended'

@Component({
    selector: 'app-search-filters-modal',
    templateUrl: 'search-filters-modal.html'
})
export class SearchFiltersModalComponent {
    moreFilters = defaultMoreFilters()
    listingCount: number
    selectedFiltersCount = 0

    @Output() $moreFiltersChange = new EventEmitter<MoreFilters>()
    @Output() $selectedFilterCountChanged = new EventEmitter<number>()

    @ViewChild(SearchFiltersExtendedComponent) searchFiltersExtended!: SearchFiltersExtendedComponent

    constructor(
        @Inject(MAT_DIALOG_DATA) data:{ moreFilters: MoreFilters, listingCount: number }) {
        this.moreFilters = data.moreFilters
        this.listingCount = data.listingCount
    }

    updateListingCount(count: number) {
        this.listingCount = count
    }

    selectedFilterCountChanged($event: number) {
        this.selectedFiltersCount = $event
        this.$selectedFilterCountChanged.emit($event)
    }

    moreFiltersChanged($event: MoreFilters) {
        this.$moreFiltersChange.emit($event)
    }

    clearAllFilters() {
        this.searchFiltersExtended.clearAllFilters()
    }
}
